import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../store/language-context';

const TimeBlock = ({ value, label }) => {
    const { language } = useLanguage();
    
    return (
        <div className="flex flex-col items-center   backdrop-blur-sm rounded-lg p-2 min-w-[50px]">
            <span className="text-3xl font-bold text-white">{value}</span>
            <span className={`text-sm text-white/90 ${language === 'ar' ? 'font-arabic' : ''}`}>
                {label}
            </span>
        </div>
    );
};

const EventTimer = ({ days, hours, minutes, seconds }) => {
    const { t } = useTranslation();
    
    return (
        <div className="flex flex-wrap justify-center gap-4">
            <TimeBlock value={days} label={t('events.timer.days')} />
            <TimeBlock value={hours} label={t('events.timer.hours')} />
            <TimeBlock value={minutes} label={t('events.timer.minutes')} />
            <TimeBlock value={seconds} label={t('events.timer.seconds')} />
        </div>
    );
};

export default EventTimer;
